function isExpiredSinceLessThan(todayDateJs, fieldValueAsDateJs, dayJsUnitTechnicalKey, dateTargetNumber) {
    var diffBetweenTodayAndFieldDateValue = todayDateJs.diff(fieldValueAsDateJs, dayJsUnitTechnicalKey);
    return (diffBetweenTodayAndFieldDateValue > 0 && diffBetweenTodayAndFieldDateValue < dateTargetNumber);
}

export { isExpiredSinceLessThan };
//# sourceMappingURL=isExpiredSinceLessThan.js.map
